import {updateAbility} from './ability'

const userStore = {
  state: {
    user: null
  },
  actions: {

    setUser (context, user) {
      context.commit('mutUser', user)
    },
  },
  mutations: {
    mutUser (state, user) {
      state.user = user
      updateAbility(user.content)
      // update users
    }
  }
}

export default userStore
